import { AnchorHTMLAttributes, DetailedHTMLProps, ElementType, FC, HTMLProps } from 'react'
import NextLink, { LinkProps } from 'next/link'
import styled, { StyledComponent } from '@emotion/styled'
import { Theme } from '@emotion/react'

type TLibAnchorStyles = {
    isBold?: boolean
    isColorized?: boolean
}

const defaultStyledAnchor = styled.a<TLibAnchorStyles>`
    text-align: center;
    font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
    color: ${({ isColorized, theme }) =>
        isColorized ? theme.colors.primary : theme.colors.secondary};
    cursor: pointer;
    outline: none;
`

type TLibAnchor = HTMLProps<HTMLAnchorElement> & {
    href: string
    isExternal?: boolean
    LinkProps?: LinkProps
    StyledAnchor?: StyledComponent<
        { theme?: Theme; as?: ElementType | string } & TLibAnchorStyles,
        DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
    >
}

const LibAnchor: FC<TLibAnchor & TLibAnchorStyles> = ({
    LinkProps = {},
    children,
    href,
    isExternal = false,

    StyledAnchor = defaultStyledAnchor,
    isColorized = false,
    isBold = false,
    ...props
}) =>
    isExternal ? (
        <StyledAnchor
            href={href}
            target="_blank"
            rel="noopener noreferrer nofollow"
            isColorized={isColorized}
            isBold={isBold}
            {...props}
        >
            {/* @ts-ignore */}
            {children}
        </StyledAnchor>
    ) : (
        <NextLink href={href} {...LinkProps} passHref legacyBehavior>
            <StyledAnchor isColorized={isColorized} isBold={isBold} {...props}>
                {/* @ts-ignore */}
                {children}
            </StyledAnchor>
        </NextLink>
    )

export type { TLibAnchor, TLibAnchorStyles }
export { LibAnchor }
